export default "__VITE_ASSET__p1ejMzzf__"